export default __webpack_public_path__ + "media/react/gre/adaptive_prep_v2/assets/circle_checkmark-0df0126f5848c388a13ab4208af7bae5.svg";